
import {share, tap, map} from 'rxjs/operators';
import { Injectable, Inject, PLATFORM_ID } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";

import { JoinSessionVM } from "../components/models/JoinSessionVM";
import { JoinSessionResponseVM } from "../components/models/JoinSessionResponseVM";
import { SessionStatus } from "../components/models/SessionStatus";
import { IMSyncResponseVM } from "../components/models/IMSyncResponseVM";
import { SessionInfoVM } from "../components/models/SessionInfoVM";

@Injectable()
export class CommsService {

  public activeSessionInfo: SessionInfoVM = new SessionInfoVM();
  public isOtherPartyOnline: boolean = false;
  public isOtherPartyTyping: boolean = false;

  constructor(
    private http: HttpClient) {
  }

  public joinSession(session: JoinSessionVM): Observable<JoinSessionResponseVM> {
    return this.http.post('/api/join-session', session, this.getHttpOptions(false)).pipe(
      map(resp => resp as JoinSessionResponseVM));
  }

  public validateSession(): Observable<SessionStatus> {
    return this.http.get('/api/validate-session', this.getHttpOptions(true)).pipe(
      map(resp => resp as SessionStatus));
  }

  public sessionInfo(): Observable<SessionInfoVM> {
    return this.http.get('/api/session-info', this.getHttpOptions(true)).pipe(
      map(resp => resp as SessionInfoVM));
  }

  public listen(ts: Date, typing: boolean): Observable<IMSyncResponseVM> {
    if (!typing) {
      var url = '/api/im-session/sync';
      return this.http.get(url, this.getHttpOptions(true)).pipe(
        map(resp => resp as IMSyncResponseVM),
        tap(sync => {
          this.isOtherPartyOnline = sync.isOtherPartyOnline;
          this.isOtherPartyTyping = sync.isOtherPartyTyping;
        }),
        share(),);
    }
    else {
      var url = '/api/im-session/typing';
      return this.http.get(url, this.getHttpOptions(true)).pipe(
        map(resp => resp as IMSyncResponseVM),
        tap(sync => {
          this.isOtherPartyOnline = sync.isOtherPartyOnline;
          this.isOtherPartyTyping = sync.isOtherPartyTyping;
        }),
        share(),);
    }
  }

  public getChatHistory(): Observable<IMSyncResponseVM> {
    return this.http.get('/api/im-session', this.getHttpOptions(true)).pipe(
      map(resp => resp as IMSyncResponseVM),
      tap(sync => {
        this.isOtherPartyOnline = sync.isOtherPartyOnline;
        this.isOtherPartyTyping = sync.isOtherPartyTyping;
      }),
      share(),);
  }

  public sendIM(msg: string): Observable<boolean> {
    return this.http.post('/api/im-session', JSON.stringify(msg), this.getHttpOptions(true)).pipe(
      map((resp: any) => {return resp.ok}));
  }

  public video(): Observable<string> {
    return this.http.get('/api/video-session', this.getHttpOptions(true)).pipe(
      map(resp => resp as string));
  }

  protected getHttpOptions(authenticated: boolean, params?: URLSearchParams) {

    if (authenticated) {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('sessionToken')
      });
      return { headers: headers };
    }

    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return (params != null) ? { headers: headers, search: params } : { headers: headers };
  }

}
